export class LoginRequestModel {
    Username: string = "";
    Password: string = "";
    SpecialToken: string="";
    Provider:string="";
}